module.exports = __webpack_public_path__ + "img/nd.7966b83.svg";